import RequireAuth from '@converge/ui/domain/auth/require-auth';
import { TabClaims } from '@converge/ui';

export const ClaimEntityPage = () => {
  return (
    <RequireAuth>
      <TabClaims />
    </RequireAuth>
  );
};

export default ClaimEntityPage;
